module.exports = __webpack_public_path__ + "static/mui_theme_creator_logo-5cbe63443051aff07e472cbbdf780059.png";